import React, { useState } from 'react';
import DashboardLayout from '../components/DashboardLayout';
import BacktestDashboard from '../components/Backtest/BacktestDashboard';
import BacktestHistoryList from '../components/Backtest/BacktestHistoryList';

// Back arrow icon
const BackIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 19l-7-7m0 0l7-7m-7 7h18" />
  </svg>
);

const Backtest = () => {
  const [selectedBacktestId, setSelectedBacktestId] = useState(null);

  // Handle selecting a backtest from the list
  const handleSelectBacktest = (backtestId) => {
    setSelectedBacktestId(backtestId);
  };

  // Handle going back to the list
  const handleBackToList = () => {
    setSelectedBacktestId(null);
  };

  // Handle delete - just refresh by clearing selection
  const handleDelete = (deletedId) => {
    if (selectedBacktestId === deletedId) {
      setSelectedBacktestId(null);
    }
  };

  return (
    <DashboardLayout>
      <div className="p-4 h-full overflow-auto">
        <div className="card bg-base-100 shadow-lg w-full min-h-full">
          <div className="card-body">
            {/* Header */}
            <div className="flex items-center gap-4 mb-6">
              {selectedBacktestId && (
                <button
                  className="btn btn-ghost btn-sm gap-2"
                  onClick={handleBackToList}
                >
                  <BackIcon />
                  Back to List
                </button>
              )}
              <h2 className="card-title text-2xl text-base-content">
                {selectedBacktestId ? 'Backtest Results' : 'Backtest History'}
              </h2>
            </div>

            {/* Content */}
            {selectedBacktestId ? (
              // Show backtest details
              <BacktestDashboard
                backtestId={selectedBacktestId}
                onError={(error) => {
                  console.error('Error loading backtest:', error);
                  // Optionally go back to list on error
                }}
              />
            ) : (
              // Show backtest list
              <BacktestHistoryList
                onSelect={handleSelectBacktest}
                onDelete={handleDelete}
              />
            )}
          </div>
        </div>
      </div>
    </DashboardLayout>
  );
};

export default Backtest;
